import * as React from "react"

/**
 * Prevents the browser default behaviour, which is to open the file.
 */
const DragDropPreventer = ({ children }: { children: React.ReactNode }): JSX.Element => {
  React.useEffect(() => {
    const voidHandler: EventListener = (event) => {
      event.preventDefault()
    }

    window.addEventListener("dragover", voidHandler)
    window.addEventListener("drop", voidHandler)

    return () => {
      window.removeEventListener("dragover", voidHandler)
      window.removeEventListener("drop", voidHandler)
    }
  }, [])

  return <>{children}</>
}

export default DragDropPreventer
